import Vue from 'vue'
import VueRouter from 'vue-router'
import App from './App.vue'
import router from './routes';
import { Row, Col, Checkbox, CheckboxGroup, Select, Option, Button, Menu, MenuItem, Submenu, Header, Container, Footer, Popover, Tooltip, Divider, Card ,Dropdown,Dialog, Form, FormItem, Input} from 'element-ui';
import 'element-ui/lib/theme-chalk/display.css';
import './assets/swiper/swiper.min.css';
import i18n from "./i18n";
import 'animate.css'
import '@/utils/ga.js'
import 'wowjs/css/libs/animate.css';
import header from "./components/navMenu";
import footer from './components/navFooter'
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'

Vue.use(Viewer);
Viewer.setDefaults({
  'inline': false, //启用inline模式
  'button': true, //显示右上角关闭按钮
  'navbar': false, //显示缩略图导航
  'title': false, //显示当前图片的标题
  'toolbar':{
    'play':false,
    'prev':true,
    'next':true
  }, //显示工具栏
  'tooltip': false, //显示缩略百分比
  'movable': false, //图片是否可移动
  'zoomable': false, //图片是否可缩放
  'rotatable': false, //图片是否可旋转
  'scalable': false, //图片是否可反转
  'transition': false, //使用css3过度
  'fullscreen': false, //播放时是否全屏
  'keyboard': true, //
  
})
Vue.use(Row);
Vue.use(Col);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(Button);
Vue.use(Option);
Vue.use(Select);
Vue.use(Menu);
Vue.use(MenuItem);
Vue.use(Dropdown);
Vue.use(Dialog);
Vue.use(Submenu);
Vue.use(Header);
Vue.use(Container);
Vue.use(Footer);
Vue.use(Popover);
Vue.use(Tooltip);
Vue.use(Divider);
Vue.use(Card);
Vue.use(VueRouter);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Input);

Vue.component('Header', header)
Vue.component('Footer', footer)

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
  router,
  i18n,
}).$mount('#app')
